module.exports = __webpack_public_path__ + "media/app/assets/character-profile-background-15f23372e6ee070e8ad952dc89568b41.png";